import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const rows = [{
  label: 'Velocidad',
  sin: '1 mueble cada 3 días',
  con: '5 muebles por semana'
}, {
  label: 'Precisión',
  sin: 'Medir 20 veces',
  con: 'Jigs: cero medición'
}, {
  label: '5 pedidos juntos',
  sin: 'Estrés total',
  con: 'Flujo controlado'
}, {
  label: 'Tu negocio sin vos',
  sin: 'Para',
  con: 'Funciona con ayudante'
}, {
  label: 'Facturación mensual',
  sin: '$600K-$900K ARS',
  con: '$1.4M-$2.1M ARS'
}];
export function MicroFabrica() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-134">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-135">
        <motion.h2 initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-black text-wood-dark mb-8 text-center" data-id="element-136">
          ¿QUÉ AGREGA EL SISTEMA MICRO-FÁBRICA?
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="overflow-x-auto" data-id="element-137">
          <table className="w-full text-left border-collapse min-w-[500px]" data-id="element-138">
            <thead data-id="element-139">
              <tr data-id="element-140">
                <th className="p-3 bg-cream-dark text-wood-dark font-bold border-b-2 border-wood-light/20 w-1/4 rounded-tl-xl text-sm" data-id="element-141"></th>
                <th className="p-3 bg-red-50 text-red-900 font-bold border-b-2 border-red-200 w-[37.5%] text-sm" data-id="element-142">
                  Sin Sistema
                </th>
                <th className="p-3 bg-amber/20 text-wood-dark font-bold border-b-2 border-amber w-[37.5%] rounded-tr-xl text-sm" data-id="element-143">
                  Con Sistema
                </th>
              </tr>
            </thead>
            <tbody data-id="element-144">
              {rows.map((row, i) => <tr key={i} className="border-b border-wood-light/10" data-id="element-145">
                  <td className="p-3 font-medium text-wood-dark text-sm" data-id="element-146">
                    {row.label}
                  </td>
                  <td className="p-3 text-red-800/70 text-sm" data-id="element-147">{row.sin}</td>
                  <td className="p-3 text-wood-dark font-bold bg-amber/5 text-sm" data-id="element-148">
                    <span className="flex items-center" data-id="element-149">
                      <ArrowRight className="w-3 h-3 text-amber mr-1.5 flex-shrink-0" data-id="element-150" />
                      {row.con}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </motion.div>
      </div>
    </section>;
}